import { useEffect } from 'react';
import { useFeatureFlagEnabled as usePostHogFeatureFlagEnabled } from 'posthog-js/react';
import { datadogRum } from '@datadog/browser-rum';
import {
  DATADOG_APPLICATION_ID,
  DATADOG_CLIENT_TOKEN,
  DATADOG_RUM_ENABLED,
} from '../config';

const datadogRumEnabled =
  DATADOG_RUM_ENABLED && DATADOG_APPLICATION_ID && DATADOG_CLIENT_TOKEN;

export function useFeatureFlagEnabled(flag) {
  const enabled = usePostHogFeatureFlagEnabled(flag);

  useEffect(() => {
    if (datadogRumEnabled && enabled !== undefined) {
      datadogRum.addFeatureFlagEvaluation(flag, enabled);
    }
  }, [flag, enabled]);

  return enabled;
}
